module["exports"] = [
  "/34##-######-####L/",
  "/37##-######-####L/"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en/credit_card/american_express.js
 ** module id = 302
 ** module chunks = 0
 **/